import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*

This file exports a COLORS object.
Allows devs to use intellisense to find the color they need without needing to remember it's hex value.

Rather than needing to remember our primary color when hovered,
the COLORS object can be imported and the value can be used via COLORS.primary.hover, COLORS.negative.disabled, etc.

properties include:

primary
secondary
positive
negative
warning

background
surface
typography
border
notification
text
buttons

*/

import { BLUE, GREEN, RED, GRAY, WHITE, AMBER, VIOLET } from "./hex";
import BUTTONS from "./buttons";
var palette = {
  primary: {
    /** Color Name: blue-10 */
    main: BLUE[10],
    /** Color Name: blue-11 */
    hover: BLUE[11],
    /** Color Name: blue-10 */
    focus: BLUE[10],
    /** Color Name: blue-09 */
    active: BLUE[9],
    /** Color Name: gray-15 */
    disabled: GRAY[15]
  },
  secondary: {
    /** Color Name: gray-10 */
    main: GRAY[10],
    /** Color Name: gray-11 */
    hover: GRAY[11],
    /** Color Name: gray-10 */
    focus: GRAY[10],
    /** Color Name: gray-09 */
    active: GRAY[9],
    /** Color Name: gray-15 */
    disabled: GRAY[15]
  },
  positive: {
    /** Color Name: green-15 */
    main: GREEN[15],
    /** Color Name: green-16 */
    hover: GREEN[16],
    /** Color Name: green-15 */
    focus: GREEN[15],
    /** Color Name: green-14 */
    active: GREEN[14],
    /** Color Name: gray-15 */
    disabled: GRAY[15]
  },
  negative: {
    /** Color Name: red-11 */
    main: RED[11],
    /** Color Name: red-12 */
    hover: RED[12],
    /** Color Name: red-11 */
    focus: RED[11],
    /** Color Name: red-10 */
    active: RED[10],
    /** Color Name: gray-15 */
    disabled: GRAY[15]
  },
  warning: {
    /** Color Name: amber-17 */
    main: AMBER[17],
    /** Color Name: amber-18 */
    hover: AMBER[18],
    /** Color Name: amber-17 */
    focus: AMBER[17],
    /** Color Name: amber-16 */
    active: AMBER[16],
    /** Color Name: gray-15 */
    disabled: GRAY[15]
  },
  magic: {
    main: VIOLET[10],
    hover: VIOLET[18],
    focus: VIOLET[17],
    active: VIOLET[16],
    disabled: GRAY[15]
  }
};
export var COLORS = _objectSpread(_objectSpread({}, palette), {}, {
  button: BUTTONS,
  /** The background color appears behind scrollable content. */
  background: {
    /** Color Name: gray-21 */
    main: GRAY[21]
  },
  /** Surface colors affect surfaces of components, such as cards, sheets, and menus. */
  surface: {
    /** Color Name: gray-21 */
    main: GRAY[21]
  },
  /** Color of typography on background colors */
  typography: {
    primary: {
      /** Color Name: white */
      main: WHITE,
      /** Color Name: white */
      hover: WHITE,
      /** Color Name: white */
      focus: WHITE,
      /** Color Name: blue-21 */
      active: BLUE[21],
      /** Color Name: gray-21 */
      disabled: GRAY[21]
    },
    secondary: {
      /** Color Name: white */
      main: WHITE,
      /** Color Name: white */
      hover: WHITE,
      /** Color Name: white */
      focus: WHITE,
      /** Color Name: gray-21 */
      active: GRAY[21],
      /** Color Name: gray-21 */
      disabled: GRAY[21]
    },
    positive: {
      /** Color Name: green-05 */
      main: GREEN[5],
      /** Color Name: green-06 */
      hover: GREEN[6],
      /** Color Name: green-05 */
      focus: GREEN[5],
      /** Color Name: green-04 */
      active: GREEN[4],
      /** Color Name: gray-21 */
      disabled: GRAY[21]
    },
    negative: {
      /** Color Name: white */
      main: WHITE,
      /** Color Name: white */
      hover: WHITE,
      /** Color Name: white */
      focus: WHITE,
      /** Color Name: red-21 */
      active: RED[21],
      /** Color Name: gray-21 */
      disabled: GRAY[21]
    },
    warning: {
      /** Color Name: amber-05 */
      main: AMBER[5],
      /** Color Name: amber-06 */
      hover: AMBER[6],
      /** Color Name: amber-05 */
      focus: AMBER[5],
      /** Color Name: amber-04 */
      active: AMBER[4],
      /** Color Name: gray-21 */
      disabled: GRAY[21]
    },
    surface: {
      /** Color Name: gray-05 */
      main: GRAY[5],
      /** Color Name: gray-06 */
      hover: GRAY[6],
      /** Color Name: gray-05 */
      focus: GRAY[5],
      /** Color Name: gray-04 */
      active: GRAY[4],
      /** Color Name: gray-15 */
      disabled: GRAY[15]
    }
  },
  /** Border and Stroke color */
  border: {
    container: {
      main: GRAY[18]
    },
    component: {
      main: GRAY[15],
      disabled: GRAY[18]
    }
  },
  notification: {
    info: {
      light: BLUE[19],
      dark: BLUE[5],
      selectedBorder: BLUE[14],
      selectedBackground: BLUE[18],
      hoverBackground: BLUE[18],
      focusBackground: BLUE[20]
    },
    neutral: {
      light: GRAY[21],
      dark: GRAY[5]
    },
    positive: {
      light: GREEN[17],
      dark: GREEN[5]
    },
    negative: {
      light: RED[16],
      dark: RED[5],
      selectedBorder: RED[11],
      selectedBackground: RED[15],
      hoverBackground: RED[15],
      focusBackground: RED[17]
    },
    warning: {
      light: AMBER[20],
      dark: AMBER[5],
      selectedBorder: AMBER[13],
      selectedBackground: AMBER[17],
      hoverBackground: AMBER[17],
      focusBackground: AMBER[19]
    },
    magic: {
      light: VIOLET[20],
      dark: VIOLET[5]
    }
  },
  text: {
    contrast: {
      high: GRAY[5],
      low: GRAY[10]
    }
  },
  input: {
    "default": {
      main: {
        color: GRAY[15],
        label: GRAY[10],
        background: 'transparent'
      },
      focus: {
        color: palette.primary.main,
        label: palette.primary.main,
        background: 'transparent'
      }
    },
    highlight: {
      main: {
        color: palette.primary.main,
        label: palette.primary.main,
        background: 'transparent'
      },
      focus: {
        color: palette.primary.main,
        label: palette.primary.main,
        background: BLUE[18]
      }
    },
    error: {
      main: {
        color: RED[9],
        label: RED[9],
        background: 'transparent'
      },
      focus: {
        color: RED[9],
        label: RED[9],
        background: RED[18]
      }
    },
    validated: {
      main: {
        color: GREEN[11],
        label: GREEN[11],
        background: 'transparent'
      },
      focus: {
        color: GREEN[11],
        label: GREEN[11],
        background: GREEN[18]
      }
    },
    warning: {
      main: {
        color: AMBER[12],
        label: AMBER[12],
        background: 'transparent'
      },
      focus: {
        color: AMBER[12],
        label: AMBER[12],
        background: AMBER[18]
      }
    }
  },
  radio: {
    main: {
      selected: palette.primary.main,
      unselected: palette.secondary.main,
      inner: WHITE
    },
    hover: {
      selected: BLUE[20],
      unselected: GRAY[20]
    },
    disabled: {
      color: palette.primary.disabled
    }
  },
  checkbox: {
    checked: {
      main: {
        color: palette.primary.main,
        inner: BLUE[21],
        background: 'transparent'
      },
      hover: {
        color: palette.primary.main,
        inner: BLUE[21],
        background: BLUE[18]
      },
      disabled: {
        color: palette.primary.disabled,
        inner: BLUE[21],
        background: 'transparent'
      }
    },
    unchecked: {
      main: {
        color: palette.secondary.main,
        inner: GRAY[21],
        background: 'transparent'
      },
      hover: {
        color: palette.secondary.main,
        inner: GRAY[21],
        background: GRAY[20]
      },
      disabled: {
        color: palette.secondary.disabled,
        inner: GRAY[21],
        background: 'transparent'
      }
    }
  },
  "switch": {
    main: {
      selected: palette.primary.main,
      unselected: palette.secondary.main
    },
    hover: {
      selected: BLUE[20],
      unselected: GRAY[20]
    },
    disabled: {
      color: palette.primary.disabled
    },
    white: WHITE
  },
  boxShadow: {
    shadow1: 'rgba(59, 65, 83, 0.18)',
    shadow2: 'rgba(59, 65, 83, 0.14)',
    shadow3: 'rgba(59, 65, 83, 0.12)'
  }
});